import { render, staticRenderFns } from "./VNumberPicker.vue?vue&type=template&id=96479860&scoped=true&"
import script from "./VNumberPicker.vue?vue&type=script&lang=ts&"
export * from "./VNumberPicker.vue?vue&type=script&lang=ts&"
import style0 from "./VNumberPicker.vue?vue&type=style&index=0&id=96479860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96479860",
  null
  
)

export default component.exports